import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../../../webcommon/common/actionbutton/ActionButton';
import { noop } from 'lodash';
import defaultStyles from './OverwriteTemplate.module.scss';
import LoadingText from '../loadingtext/LoadingText';

const OverwriteTemplate = props => (
    <div className={ props.styles.overwriteWrapper }>
        <div className={ props.styles.overwriteHeader }>
            A template with this name already exists. Are you sure you want to overwrite it?
        </div>
        <div className={ props.styles.saveButton }>

            <ActionButton
                onClick={ props.cancel }
            >
                Cancel
            </ActionButton>

            <ActionButton
                accent
                onClick={ props.overwriteTemplate }
            >
                Yes
            </ActionButton>
        </div>

        {props.templateSaved
            ? <div className={ props.styles.templateSaved }>Template Saved</div> : null}
        {!props.templateSaved && props.inProcessOfSaving
            ? <div className={ props.styles.templateSaved }> <LoadingText text="Loading" /></div> : null}
    </div>
);

OverwriteTemplate.propTypes = {
    cancel: PropTypes.func,
    inProcessOfSaving: PropTypes.bool,
    overwriteTemplate: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    templateSaved: PropTypes.bool
};

OverwriteTemplate.defaultProps = {
    cancel: noop,
    inProcessOfSaving: false,
    overwriteTemplate: noop,
    styles: defaultStyles,
    templateSaved: false
};

export default OverwriteTemplate;
